import { gql } from '@apollo/client';

export const UPDATE_AGENT_TOOL = gql`
  mutation UpdateAgentTool($params: UpdateAgentToolInput!) {
    updateAgentTool(params: $params) {
      success
      message
      errors
      data {
        id
        agentConfigId
        toolKey
        description
        createdAt
        createdBy
      }
    }
  }
`;
